import { NavLink, Link } from "react-router-dom";
import { Feather, LayoutDashboard, Coins, CandlestickChart, Users, Compass, Star, Bell, Menu, X, Grid3x3 } from "lucide-react";
import { useState } from "react";
import GlobalSearch from "./GlobalSearch";
import ConnectWallet from "./ConnectWallet";

const NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/tokens", label: "Tokens", icon: Coins },
  { to: "/heatmap", label: "Heatmap", icon: Grid3x3 },
  { to: "/stocks", label: "Stock Tokens", icon: CandlestickChart },
  { to: "/accounts", label: "Top Accounts", icon: Users },
  { to: "/explorer", label: "Explorer", icon: Compass },
  { to: "/watchlist", label: "Watchlist", icon: Star },
  { to: "/alerts", label: "Alerts", icon: Bell },
];

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F3F4F6]">
      <header className="fixed top-0 inset-x-0 h-12 bg-[#0A0A0A] border-b border-[#262626] z-40 flex items-center gap-3 px-3">
        <button className="lg:hidden text-[#9CA3AF]" onClick={() => setOpen(!open)} data-testid="mobile-menu-button">
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="logo-link">
          <span className="relative flex items-center justify-center w-7 h-7 border border-[#059669] rounded-sm">
            <Feather size={15} className="text-[#10B981]" />
          </span>
          <span className="font-heading font-black text-base tracking-tight hidden sm:block">FEATHER</span>
          <span className="hidden md:block text-[10px] uppercase tracking-widest text-[#6B7280] border-l border-[#262626] pl-2">Robinhood Chain</span>
        </Link>
        <div className="flex-1 max-w-xl mx-auto"><GlobalSearch /></div>
        <ConnectWallet />
      </header>

      <aside className={`fixed top-12 bottom-0 left-0 w-52 bg-[#0A0A0A] border-r border-[#262626] z-30 overflow-y-auto transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <nav className="py-2">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to} to={to} end={end}
              onClick={() => setOpen(false)}
              data-testid={`nav-${label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-4 py-2 text-[13px] border-l-2 transition-colors ${
                  isActive ? "border-[#059669] text-[#F3F4F6] bg-[#12121280]" : "border-transparent text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#121212]"}`}
            >
              <Icon size={15} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-3 mt-4 border-t border-[#262626] text-[10px] text-[#6B7280] leading-relaxed">
          Live data from Robinhood Chain RPC &amp; Blockscout.<br />Chain ID 4663
        </div>
      </aside>
      {open && <div className="fixed inset-0 top-12 bg-black/60 z-20 lg:hidden" onClick={() => setOpen(false)} />}

      <main className="pt-12 lg:pl-52 min-h-screen">
        <div className="p-3 md:p-4 max-w-[1600px]">{children}</div>
      </main>
    </div>
  );
}
